import React from "react";

const FAQs = ({ faqs }) => {
  return (
    <section className="faqs" aria-labelledby="faq-title">
      <div className="container">
        <div className="section-head">
          <h2 id="faq-title">
            Questions, <em>answered</em>
          </h2>
        </div>

        <div className="faq-list">
          {faqs.map((faq) => (
            <details key={faq.question} className="faq-item" open={faq.open}>
              <summary>{faq.question}</summary>

              <div className="faq-answer">{faq.answer}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
